module.exports = __webpack_public_path__ + "media/U_illustration.93c6a738.mp3";